// Black magic that calculates the effective interest.
const irr = (cashFlow, estimate) => {
    var x = 1 / (1 + estimate);
    var N = cashFlow.length;
    for (var iter = 0; iter < 10; iter++) {
      var f = cashFlow[N - 1];
      var df = (N - 1) * cashFlow[N - 1];
      for (var i = N - 2; i >= 1; i--) {
        f = f * x + cashFlow[i];
        df = df * x + i * cashFlow[i];
      }
      f = f * x + cashFlow[0];
      var newx = x - f / df;
      if (Math.abs(x - newx) < 1e-6) {
        return 1 / newx - 1;
      }
      x = newx;
    }
    return NaN;
  }
  
  const calc = (loan) => {
    const terms = loan.years;
  
    // Calculate the per month interest rate.
    const dividedIntrestRate = loan.interestRate / 100;
    const monthlyRate = dividedIntrestRate / 12;
  
    // For IRR computation
    let cashFlow = [-loan.balance + loan.arrangementFee];
    
    //pay dircetly... but push fees for all month e.g. customer select 4 months calc that customer pays month number 4
    if(loan.buyNow) {
      for(let i=1; i<=terms; i++) {
        if(terms === i) {
          cashFlow.push( loan.balance + loan.adminFee )
        } else {
          cashFlow.push(0);
        }
      }
    } else {
      //grace month if not pay now 
      cashFlow.push(0);
    }

  
    // Check what type of loan it is.
    const isAnnu = loan.loanType === 'annu';
  
  
    let remainingBalance = loan.balance;
    let totalPayment = loan.arrangementFee;
  
    // Loaninformation for each term.
    let allMonthsInfo = [];
  
    for (let term = 0; term <= terms; term++) {
      // Push first month in to array. This is where you only pay the arrangementFee.
      if (term === 0) {
        allMonthsInfo.push({
          debt: 0,
          amortization: 0,
          interest: 0,
          fees: loan.arrangementFee,
          monthlyCost: loan.arrangementFee,
        });
      } else {
        const interest = (remainingBalance * monthlyRate);
        let paymentBeforeFees;
        let amortization;
  
        if (isAnnu) {
          const r = 1 / (1 + monthlyRate);
          paymentBeforeFees = (remainingBalance / ((1 - Math.pow(r, terms + 2 - term)) / (1 - r) - 1));
          amortization = paymentBeforeFees - interest;
        } else {
          amortization = (remainingBalance / (terms + 1 - term));
          paymentBeforeFees = amortization + interest;
        };
  
        let payment = paymentBeforeFees + loan.adminFee;
        
        if(!loan.buyNow) {
          cashFlow.push(payment);
        }
      
        totalPayment += payment;
  
        if (term === 1) {
          var firstPayment = payment;
        };
  
        allMonthsInfo.push({
          debt: remainingBalance.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
          amortization: amortization.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
          interest: interest.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
          fees: loan.adminFee,
          monthlyCost: payment.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' '),
        });
        remainingBalance -= amortization;
      };
    };
  
    var feeNumber = totalPayment - loan.balance;
  
    let tidyPaymentNumber = firstPayment.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    let effectiveInterest = (100 * (Math.pow(1 + irr(cashFlow, monthlyRate), 12) - 1)).toFixed(2);
    let tidyFeeNumber = feeNumber.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
    if (isNaN(firstPayment) || isNaN((100 * (Math.pow(1 + irr(cashFlow, monthlyRate), 12) - 1))) || isNaN(feeNumber)) {
      tidyPaymentNumber = '-';
      effectiveInterest = '-';
      tidyFeeNumber = '-';
    }
  
    return {
      allMonthsInfo: allMonthsInfo,
      tidyPaymentNumber: tidyPaymentNumber,
      effectiveInterest: effectiveInterest,
      tidyFeeNumber: tidyFeeNumber
    };
  }

const MonthlyCalculation = (L, r, n) => {
    // L is loan amount
    // r is APR
    // n is number of months
    // P is the monthly cost
    const P = L * r * Math.pow(1 + r / 1200, n) / (1200 * (Math.pow(1 + r / 1200, n) - 1));
    return P;
}


const magic = ({loansum,intrest = 0.00001,loantimemonths = 12, servicefee = 29, opening = 295, buyNow=false}) => {
    const monthly = MonthlyCalculation(loansum, intrest, loantimemonths);
    const servicewhole = loantimemonths * servicefee + opening;
    const loantotal = (monthly * loantimemonths) + servicewhole;
    const test = calc({ adminFee: servicefee,
        arrangementFee: Number(opening),
        balance: Number(loansum),
        interestRate: intrest,
        loanType: "annu",
        years: Number(loantimemonths),
        buyNow});
        
    return { 
        effectiveInterestRate: Number(test.effectiveInterest), 
        monthlyCost: monthly,
        totalFee: servicewhole,
        totalCost: loantotal
    }
}


export default magic;